import styled from 'styled-components';
import { AlertBanner } from '@tryhackme/thm-ui-components';

export const StyledAzureEnvironment = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const StyledEnvStateAndTag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const StylesEnvStateText = styled.p`
  margin-right: 1.6rem;
`;

export const StyledCredentialsAlert = styled(AlertBanner)`
  margin: 2rem 0 0 0;

  div {
    padding: 0 0.5rem;
  }
`;

export const StyledCredentials = styled.ul`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin: 2rem 0 0 0;
  color: ${({ theme }) => theme.colors.text.main};

  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledCredential = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`;

export const StyledCredentialField = styled.div`
  width: 8rem;
`;

export const StyledSectionHeader = styled.h5`
  margin: 0;
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
`;

export const StyledActions = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  align-content: flex-start;
`;

export const StyledPillLabel = styled.div`
  text-transform: capitalize;
`;
